var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.60416 34.088C4.56816 34.088 4.56816 34.088 4.53216 34.088C4.06416 34.052 3.74017 33.656 3.77617 33.224C4.24417 26.348 10.7242 20.984 18.5002 20.984C26.2762 20.984 32.7562 26.348 33.2242 33.188C33.2602 33.656 32.9002 34.016 32.4682 34.052C32.0002 34.088 31.6402 33.728 31.6042 33.296C31.1722 27.284 25.4122 22.604 18.5002 22.604C11.5522 22.604 5.79217 27.32 5.39617 33.332C5.36017 33.764 5.00016 34.088 4.60416 34.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.501 19.328C13.965 19.328 10.293 15.656 10.293 11.12C10.293 6.58399 13.965 2.91199 18.501 2.91199C23.037 2.91199 26.709 6.58399 26.709 11.12C26.709 15.656 23.037 19.328 18.501 19.328ZM18.501 4.56799C14.901 4.56799 11.949 7.51999 11.949 11.12C11.949 14.72 14.901 17.672 18.501 17.672C22.101 17.672 25.053 14.72 25.053 11.12C25.053 7.51999 22.101 4.56799 18.501 4.56799Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.3e318fc512982eca52b2e1322f708d0a.svg";
export { ForwardRef as ReactComponent };